const { en: common } = require("../../common");

module.exports = {
	...common,
	features: require("./features-page.json"),
	"section-try-for-free": require("../../section-try-for-free/en/section-try-for-free.json"),
};
